import React, {useMemo} from 'react';

import {useStore} from 'effector-react';

import {activeStatusBarChart$} from '../../../../../models/dashboard';
import {ProductStatusRecord} from '../../../../../types';
import {DefectChartColors} from '../ProductStatusChart';

import {Bar, LegendItem, BarContainer, LegendItemHeader, PercentLabel} from './styled';

interface Props {
    data: ProductStatusRecord[];
    className?: string;
}

interface BarProps {
    percent: number;
    color: string;
    height?: number;
    className?: string;
}

export function PercentBar({percent, color, height = 10, className}: BarProps) {
    return (
        <BarContainer className={className} height={height}>
            <Bar key={color} color={color} width={percent} />
        </BarContainer>
    );
}

export const ProductStatusLegend = ({data, className}: Props) => {
    const activeItem = useStore(activeStatusBarChart$);
    const sum = useMemo(() => data.reduce((sum, {value}) => sum + value, 0), [data]);
    const percentsData = useMemo(
        () =>
            data.map((item, index) => ({
                percent: Math.round((item.value / sum) * 10000) / 100 || 0,
                value: item.value,
                label: item.label,
                color: DefectChartColors[item.status || ''],
                isActive: activeItem === null || activeItem === item.label,
            })),
        [data, activeItem, sum],
    );
    return (
        <>
            {percentsData.map((item) => (
                <LegendItem isActive={item.isActive} key={item.label}>
                    <LegendItemHeader>
                        <span>{item.label}</span>
                        <PercentLabel>{item.value}</PercentLabel>
                    </LegendItemHeader>
                    <PercentBar color={item.color} percent={item.percent} />
                </LegendItem>
            ))}
        </>
    );
};
